module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av519-9937805e952706c65aa534d1e5e0b1d1.jpg";